export default __webpack_public_path__ + "static/theia-ide-ai-demo-08ccf5594e58b9a67a1a7feab6f188a6.mp4";